<div #mobileOffcanvas class="offcanvas offcanvas-bottom" tabindex="-1" [id]="content?.id" [attr.aria-labelledby]="(content?.id ||'offcanvas')+'Label'">
  <div class="offcanvas-header header-sec">
    <div class="heading">Your cover & benefits</div>
    <button type="button" id="" name="" class="btn-close text-reset pt-2" (click)="closeOffcanvas()"></button>
  </div>
 <div class="offcanvas-body">
    <div class="block-sec">
      <div class="head text-start">Your policy benefits</div>
      <div class="divider_yellow"></div>
      <ul>
        <li>The Policy insures you and your credit providers, who require Compulsory Credit Life Insurance from you,
          against your <span class="font-weight-bold">death, permanent disability, temporary disability, critical
            illness and loss of income*.</span>
        </li>
        <div class="border-li"></div>
        <li>We will pay out the <span class="font-weight-bold">Insured Sum</span> under the <span
            class="font-weight-bold">death, permanent disability and critical illness benefits</span> in a lump sum.
        </li>
        <div class="border-li"></div>
        <li>We will pay out the <span class="font-weight-bold">Monthly Insured Sum</span> under the <span
            class="font-weight-bold">temporary disability and loss of income benefits</span> on a monthly basis for a
          <span class="font-weight-bold">maximum period of 12 months.</span>
        </li>
        <div class="border-li"></div>
        <li>Your Policy ends on the earlier of the <span class="font-weight-bold">conclusion of your debt review or your
            death.</span></li>
        <div class="border-li"></div>
        <li>Your Policy will <span class="font-weight-bold">renew automatically every year</span> on the anniversary of
          the Policy start date, unless you don't want to renew.
        </li>
      </ul>
    </div>
    <div class="block-sec">
      <div class="head text-start">Your cover</div>
      <div class="divider_yellow"></div>
      <ul class="policy-list">
        <li>Insured Sum: <span class="font-weight-bold">R {{PolicyDetailResponse?.insuredSum?? 0 | number:'1.0-2'}}</span>
        </li>
      </ul>
    </div>
    <div class="block-sec">
      <div class="head text-start">Limitations & exclusions</div>
      <div class="divider_yellow"></div>
      <ul>
        <li>Age Limitations: Beneficiaries cannot be below the age of <span class="font-weight-bold">18.</span>
        </li>
        <div class="border-li"></div>
        <li>Termination of Benefits: Your <span class="font-weight-bold">temporary and permanent disability </span>and
          <span class="font-weight-bold">loss of income </span>benefits end when you turn
          <span class="font-weight-bold">65.</span>
        </li>
        <div class="border-li"></div>
        <li>Eligibility Criteria: You do <span class="font-weight-bold">not </span>qualify for the loss of income
          benefit if you are <span class="font-weight-bold">self-employed, your work is
            temporary, seasonal or casual </span>or you are a <span class="font-weight-bold">contract worker with a
            contract term of less than 12 months. </span>
        </li>
        <div class="border-li"></div>
        <li>Waiting Periods:
          <ul>
            <li>
              <span class="font-weight-bold">For loss of income benefit:</span>
              3 months from the claim event date less any waiting period you already
              served under any replaced policies.
            </li>
          </ul>
        </li>
        <div class="border-li"></div>
        <li>Deferred Periods:
          <ul>
            <li>
              <span class="font-weight-bold">Permanent disability benefit:</span>
              6 months from the claim event date to prove permanence of the
              disability.
            </li>
            <li>
              <span class="font-weight-bold">Temporary disability benefit:</span>
              1 month from the claim event date.
            </li>
            <li>
              <span class="font-weight-bold">Loss of income benefit:</span>
              1
              month from the claim event date.
            </li>
          </ul>
    
        </li>
        <div class="border-li"></div>
        <li>Exclusions: We will not pay a claim if the claim event is
          <ul>
            <li>
              <span class="font-weight-bold">For death, disability or illness:</span>
              Caused by self-harm,
              criminal acts, unscheduled flights, war, dangerous activities, alcohol or drugs or by not following
              prescribed medical
              treatment.
            </li>
            <li>
              <span class="font-weight-bold">For a period of 12 months from the start of the Policy:</span>
              Caused by a medical condition for which you
              received medical treatment 12 months before you entered into the Policy (for Disability and Critical
              Illness) or if you
              committed suicide within 24 months of the policy start date (Death). This period will be reduced if you
              have already
              served such exclusion periods under any policies replaced by this Policy.
            </li>
            <li>
              <span class="font-weight-bold">For loss of income:</span>
              Caused because you
              resign, retire or accept voluntary retrenchment or redundancy or were aware at the start of the Policy
              that you would;
              or you lost your job due to fraud or other misconduct or unlawful strike. Or due to maternity leave,
              partial reduction
              in income, confiscation of your employer's assets or if your work contact ends early.
            </li>
          </ul>
    
        </li>
      </ul>
    </div>
    <div class="block-sec-footer">
      Individually issued policy document T&C's take precedence over the generalised information provided in your insurance
      summary.
    </div>
  </div>
</div>
